import React from 'react';

interface AzureDevOpsIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const AzureDevOpsIcon: React.FC<AzureDevOpsIconProps> = ({
  width = 24,
  height = 24,
  className,
  color = "#0078D4"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      style={{ display: 'inline-block' }}
    >
      <path 
        fill={color} 
        d="M15 3.622v8.512L11.5 15l-5.425-1.975v1.958L3.004 10.97l8.951.7V4.005L15 3.622zm-2.984.428L6.994 1v2.001L2.382 4.356 1 6.13v4.029l1.978.873V5.869l9.038-1.818z"
      />
    </svg>
  );
};

